import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import Z_Homepage from './components/Z_homepage';
import Impressum from './components/Impressum';
import Seo from './components/Seo';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Seo page="home" /><Homepage /></>} />
          <Route path="/z-intern-394" element={<><Seo page="internal" /><Z_Homepage /></>} />
          <Route path="/impressum" element={<><Seo page="impressum" /><Impressum /></>} />
          {/* später */}
          {/* <Route path="/datenschutz" element={<Datenschutz />} /> */}
          {/* <Route path="/agb" element={<AGB />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
